
import { createSlice } from "@reduxjs/toolkit";

interface GlobalSliceProps {
  isLoading: boolean;
  error: boolean;
  updatePageStore: boolean;
}

const initialState: GlobalSliceProps = {
  isLoading: false,
  error: false,
  updatePageStore : false,
};

export const globalSlice = createSlice({
  name: "globalDatum",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // Method to update page render
    handleUpdatePageSlice(state, action) {
      state.updatePageStore = action.payload;
    }
  },
});
export const { startLoading, hasError, handleUpdatePageSlice } = globalSlice.actions;

export default globalSlice.reducer;
